import React from 'react';
import { Box, Text } from '@razorpay/blade/components';

export const ChargesSummary = () => {
  return (
    <Box display="flex" flexWrap='wrap' flexDirection="row" gap="spacing.2" alignItems="center" flex="1">
      <Box
        display="flex"
        flexDirection="row"
        gap="spacing.1"
        alignItems="center"
        paddingY="spacing.1"
        paddingX="spacing.2"
        backgroundColor="surface.background.gray.intense"
        borderRadius="medium">
        <Text size="xsmall" weight="regular" color="surface.text.gray.muted">
          Payroll
        </Text>
      </Box>
      <Text size="xsmall" weight="regular" color="surface.text.gray.muted">
        +
      </Text>
      <Box
        display="flex"
        flexDirection="row"
        gap="spacing.1"
        alignItems="center"
        paddingY="spacing.1"
        paddingX="spacing.2"
        backgroundColor="surface.background.gray.intense"
        borderRadius="medium">
        <Text size="xsmall" weight="regular" color="surface.text.gray.muted">
          Razorpay Charges
        </Text>
      </Box>
    </Box>
  );
};
